import React, { memo } from "react";
import { Container } from "react-bootstrap";
import Slider from "react-slick";

const ClientsLogo = () => {
  const logos = [
    { src: "/img/plus-distribution-client-jaipur-golden-hospital.webp", alt: "Jaipur Golden Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-jaypee-hospital.webp", alt: "Jaypee Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-park-hospital.webp", alt: "Park Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-prem-hospital.webp", alt: "Prem Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-Saroj-hospital.webp", alt: "Saroj Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-yatharth-hospital.webp", alt: "Yatharth Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-Felix-hospital.webp", alt: "Felix Hospital - Client of Plus Distribution" },
    { src: "/img/plus-distribution-client-fortis-hospital.webp", alt: "Fortis Hospital - Client of Plus Distribution" },
  ];

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0, // continuous scroll
    speed: 3000,
    cssEase: "linear",
    slidesToShow: 6,
    slidesToScroll: 1,
    pauseOnHover: false, // prevents flickering
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 5 } },
      { breakpoint: 992, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <Container fluid className="my-5 py-md-4 overflow-hidden max-w-1920 mx-auto">
      <h2
        className="fw-bold fs_8xl text-center mb-5 text-black"
        data-aos="fade-down"
      >
        Our Trusted Partners
      </h2>
      <Slider {...settings}>
        {logos.map((logo, i) => (
          <div key={i} className="flex justify-center items-center">
            <img
              src={logo.src}
              alt={logo.alt}
              title={logo.alt}
              width={190}
              height={70}
              loading="lazy"
              decoding="async"
              className="object-contain p-1"
            />
          </div>
        ))}
      </Slider>
    </Container>
  );
};

export default memo(ClientsLogo);
